import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://167.71.62.249/';

const API_URL_AUTH = BASE_URL + 'auth/';

const register = (email, password) => {
    return axios.post(API_URL_AUTH + 'register/', {
        email,
        password
    });
};

const login = (email, password) => {
    return axios.post(API_URL_AUTH + 'login/', {
        email,
        password
    }).then(response => {
        if (response.data.access) {
            localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
    })
    .catch(error => {
        // Check for specific error types in the response data
      if (error.response) {
        // The request was made and the server responded with an error status
        const responseData = error.response.data;
        
        if (responseData.error === 'email_not_verified') {
          // Create a custom error with the code property
          const customError = new Error(responseData.message);
          customError.code = 'email_not_verified';
          throw customError;
        } else if (responseData.error === 'account_locked') {
          // Handle account locked scenario
          const customError = new Error(responseData.message);
          customError.code = 'ACCOUNT_LOCKED';
          customError.lockoutSeconds = responseData.lockout_seconds;
          throw customError;
        } else if (responseData.error === 'invalid_credentials') {
          // Handle invalid credentials
          const customError = new Error(responseData.message || 'Invalid credentials');
          customError.code = 'INVALID_CREDENTIALS';
          throw customError;
        }
      }
      
      // For any other errors
        throw error;
      });
};

const logout = () => {
    localStorage.removeItem('user');
};

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem('user'));
};

const getUserProfile = (token) => {
    return axios.get(API_URL_AUTH + 'user/', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

const updateUserProfile = (token, data) => {
    return axios.put(API_URL_AUTH + 'user/', data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

const deleteUserProfile = async (token, password) => {
    try {
      const response = await axios.delete(API_URL_AUTH + 'user/', {
        headers: {
          Authorization: `Bearer ${token}`
        },
        data: {
          password: password
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
};

const changePassword = (token, currentPassword, newPassword) => {
    return axios.post(API_URL_AUTH + 'change-password/',
        { old_password: currentPassword, new_password: newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
    );
};


const requestPasswordReset = (email) => {
  return axios.post(API_URL_AUTH + 'password-reset/request/', { email })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      // We still want to handle this gracefully even if the email doesn't exist
      // to prevent email enumeration attacks
      if (error.response) {
        throw new Error(error.response.data.message || 'An error occurred while requesting password reset');
      }
      throw error;
    });
};

const confirmPasswordReset = (token, newPassword, confirmPassword) => {
  return axios.post(API_URL_AUTH + 'password-reset/confirm/', {
    token,
    new_password: newPassword,
    confirm_password: confirmPassword
  })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      if (error.response) {
        throw new Error(error.response.data.error || 'An error occurred while resetting your password');
      }
      throw error;
    });
};

export default {
    register,
    login,
    logout,
    getCurrentUser,
    getUserProfile,
    updateUserProfile,
    deleteUserProfile,
    changePassword,
    requestPasswordReset,
    confirmPasswordReset
};
